import ArrowForward from '@mui/icons-material/ArrowForward'
import Close from '@mui/icons-material/Close'
import { Card, IconButton, Stack, styled, Typography, useTheme } from '@mui/material'
import type { Path, Relative, TemplateId } from '../api/api'

type PathWithActionId = Path & { actionId?: string }

interface PathRowProps {
  path: PathWithActionId
  fromRelative: Relative | undefined
  toRelative: Relative | undefined
  onRemove: (path: PathWithActionId) => void
}

const resolveName = (relative: Relative | undefined, fallback: TemplateId) => relative?.name ?? relative?.externalName ?? fallback

export const PathRow = ({ path, fromRelative, toRelative, onRemove }: PathRowProps) => {
  const { palette } = useTheme()

  return (
    <Card variant="elevation">
      <Stack
        direction="row"
        sx={{
          padding: 2,
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Stack
          direction="row"
          sx={{
            alignItems: 'center',
            gap: 1,
          }}
        >
          <Typography data-testid="path-from" variant="p2Medium">
            {resolveName(fromRelative, path.from)}
          </Typography>
          <ArrowForward fontSize="small" htmlColor={palette.text.secondary} />
          <Typography data-testid="path-to" variant="p2Medium">
            {resolveName(toRelative, path.to)}
          </Typography>
        </Stack>
        <IconButton onClick={() => onRemove(path)} aria-label="remove allowed path">
          <Close />
        </IconButton>
      </Stack>
    </Card>
  )
}
